import { EventsList } from '../../../components/Events/AdminEventsList'

export const Events = () => {
    return <EventsList />
}
